import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "nom-wrapper" }
const _hoisted_2 = { class: "nom-card" }
const _hoisted_3 = {
  key: 0,
  class: "nom-chips"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "tab-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxTabs = _resolveComponent("DxTabs")!
  const _component_MarciModele = _resolveComponent("MarciModele")!
  const _component_GridNomenclatorPam = _resolveComponent("GridNomenclatorPam")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (t, i) => {
              return (_openBlock(), _createElementBlock("button", {
                key: i,
                class: _normalizeClass(["nom-chip", { active: _ctx.selectedIndex === i }]),
                onClick: ($event: any) => (_ctx.setTab(i))
              }, _toDisplayString(t.text), 11, _hoisted_4))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["tabs-container", { 'is-mobile': _ctx.isMobile }])
      }, [
        (!_ctx.isMobile)
          ? (_openBlock(), _createBlock(_component_DxTabs, {
              key: 0,
              "data-source": _ctx.tabs,
              "selected-index": _ctx.selectedIndex,
              orientation: "vertical",
              class: "tabs",
              onOptionChanged: _ctx.onTabChanged
            }, null, 8, ["data-source", "selected-index", "onOptionChanged"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.selectedIndex === 0)
            ? (_openBlock(), _createBlock(_component_MarciModele, { key: 0 }))
            : (_ctx.selectedIndex === 1)
              ? (_openBlock(), _createBlock(_component_GridNomenclatorPam, {
                  key: 1,
                  entity: "PAM_Stare",
                  title: "Stare"
                }))
              : (_ctx.selectedIndex === 2)
                ? (_openBlock(), _createBlock(_component_GridNomenclatorPam, {
                    key: 2,
                    entity: "PAM_TipCombustibil",
                    title: "Tip Combustibil"
                  }))
                : (_ctx.selectedIndex === 3)
                  ? (_openBlock(), _createBlock(_component_GridNomenclatorPam, {
                      key: 3,
                      entity: "PAM_TipProprietate",
                      title: "Tip Proprietate"
                    }))
                  : (_ctx.selectedIndex === 4)
                    ? (_openBlock(), _createBlock(_component_GridNomenclatorPam, {
                        key: 4,
                        entity: "PAM_TipAsigurare",
                        title: "Tip Asigurare"
                      }))
                    : (_ctx.selectedIndex === 5)
                      ? (_openBlock(), _createBlock(_component_GridNomenclatorPam, {
                          key: 5,
                          entity: "PAM_Valabilitate",
                          title: "Valabilitate"
                        }))
                      : _createCommentVNode("", true)
        ])
      ], 2)
    ])
  ]))
}